import { create } from "zustand"
import { persist } from "zustand/middleware"

interface SetupWorkspaceState {
	step: number
	isSettingUpWorkspace: boolean
	justCompletedSetup: boolean
	/** The workspace this run created or joined; every later step acts on it. */
	workspaceId: string | null
	setStep: (step: number) => void
	setWorkspaceId: (workspaceId: string | null) => void
	endSetup: () => void
	completeSetup: () => void
	consumeSetupCompletion: () => void
	startSetup: () => void
	resetSetup: () => void
}

export const useSetupWorkspace = create<SetupWorkspaceState>()(
	persist(
		(set) => ({
			step: 0,
			isSettingUpWorkspace: false,
			justCompletedSetup: false,
			workspaceId: null,
			// Back at the create step, the old run's workspace no longer applies.
			setStep: (step) =>
				set(step <= 1 ? { step, workspaceId: null } : { step }),
			setWorkspaceId: (workspaceId) => set({ workspaceId }),
			endSetup: () => set({ isSettingUpWorkspace: false }),
			completeSetup: () =>
				set({
					isSettingUpWorkspace: false,
					justCompletedSetup: true,
					workspaceId: null,
				}),
			consumeSetupCompletion: () => set({ justCompletedSetup: false }),
			startSetup: () =>
				set({ isSettingUpWorkspace: true, justCompletedSetup: false }),
			resetSetup: () =>
				set({
					step: 0,
					isSettingUpWorkspace: false,
					justCompletedSetup: false,
					workspaceId: null,
				}),
		}),
		{
			name: "setup-workspace-state",
		},
	),
)
